// @ts-nocheck
import { DataTransferManager } from './dataTransfer/DataTransferManager';

/**
 * Refactored insertData extension for Slate editor
 * Now uses modular architecture following SOLID principles
 *
 * This main file serves as an orchestrator, delegating specific
 * data transfer operations to specialized handlers
 */
export const insertData = (editor) => {
  const dataTransferManager = new DataTransferManager(editor);

  // Set up data transfer handlers using the manager
  editor.dataTransferHandlers = {
    ...editor.dataTransferHandlers,
    ...dataTransferManager.getHandlers(),
  };

  // Store original insertData method
  const { insertData } = editor;

  // Override insertData method with new modular approach
  editor.insertData = async (data) => {
    if (editor.beforeInsertData) {
      editor.beforeInsertData(data);
    }

    // Try to handle data using the manager
    const handled = await dataTransferManager.handleData(data);
    if (handled) {
      return true;
    }

    // Fall back to original implementation if not handled
    return insertData(data);
  };

  return editor;
};
